/* eslint-disable no-nested-ternary */
import { FunctionComponent } from 'react';

import Icon from '../../DataDisplay/Icon/Icon';
import Modal from '../../Utility/Modal/Modal';
import Title from '../../Text/Title/Title';
import styles from './LoadingIndicator.module.scss';
import { getCSSVariable } from '../../../utils';

type Props = {
  isVisible: boolean;
  message?: string;
  noLeadingDots?: boolean;
  size?: 'md' | 'lg';
  hasNoMessage?: boolean;
  hasNoTitle?: boolean;
};

const LoadingIndicator: FunctionComponent<Props> = ({
  isVisible,
  message,
  noLeadingDots,
  size = 'md',
  hasNoMessage,
  hasNoTitle = false,
}: Props) => {
  const zIndex = getCSSVariable('--zLoadingIndicator');

  return (
    <div data-testid="loadingIndicator" data-state={isVisible ? 'visible' : 'hidden'}>
      <div className={[styles.radial, styles[getDisplayClass(isVisible)]].join(' ')} />
      <Modal isVisible={isVisible} enableBgClick={false} zIndex={Number(zIndex)}>
        <div className={styles.centered}>
          <Icon icon="loader" size={size === 'md' ? 'jumbo' : 'xl-jumbo'} />
          {!hasNoTitle && (
            <Title
              center
              title={
                hasNoMessage ? '...Loading' : noLeadingDots ? `${message || 'Loading'}` : `...${message || 'Loading'}`
              }
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

function getDisplayClass(isVisible: boolean) {
  return isVisible ? 'visible' : 'hidden';
}

export default LoadingIndicator;
